import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/categories", label: "全站分类" },
  { to: "/ranking", label: "人气排行" },
  { to: "/featured", label: "新作专题" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/categories?q=${encodeURIComponent(keyword.trim())}`);
    setOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-ink-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="天堂漫画 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
            <i className="ri-book-open-fill"></i>
          </span>
          <span className="font-heading text-lg font-black tracking-wide text-foreground-950">
            天堂<span className="text-primary-600">漫画</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <form onSubmit={submitSearch} className="flex items-center gap-1 rounded-full border border-background-300 bg-background-50 px-3 py-1.5">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画 / 作者"
              className="w-32 bg-transparent text-sm outline-none placeholder:text-foreground-500"
              aria-label="搜索漫画"
            />
          </form>
          <Link
            to="/contact"
            className="whitespace-nowrap rounded-full bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
          >
            意见反馈
          </Link>
        </div>

        <button
          className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-900 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={submitSearch} className="mb-3 flex items-center gap-1 rounded-full border border-background-300 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画 / 作者"
              className="w-full bg-transparent text-sm outline-none"
              aria-label="搜索漫画"
            />
          </form>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-2.5 text-sm transition-colors ${
                    isActive ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-primary-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-full bg-secondary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              意见反馈
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}